<template>
  <div class="h-full w-full flex items-center justify-center">
    <span
      class="block w-[60px] h-[60px] border-[5px] border-solid border-transparent border-t-black rounded-full animate-spin"
    >
    </span>
  </div>
</template>

<script>
export default {
  name: "loadingSpinner",
};
</script>
